module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/PlFyJa/Images/cover.jpg?1684571222821",
      "alt": "This image is the cover for the book Waiting for the Moon and You"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Waiting for the Moon and You\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("All his life, Leith has loved Aaron, and all his life, Leith has wondered if Aaron returns his feelings. Through high school, college, and beyond, Leith and Aaron are drawn together and pulled apart. Leith is finally convinced he and Aaron are not meant to be when a cowardly act of violence against Leith changes everything.")]), _vm._v(" "), _c('p', [_vm._v("Aaron returns to Leith's side, but Leith struggles to accept that Aaron can love him now.")]), _vm._v(" "), _c('p', [_vm._v("If Leith doesn’t overcome his doubts and fears, he will forever be waiting for the moon and Aaron… and true love.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      L.J. LaBarthe\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0